/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InsightsInputs */

const nl_nav_insights = /** @type {(inputs: Nav_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzichten`)
};

/**

* @param {Nav_InsightsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_insights = /** @type {((inputs?: Nav_InsightsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InsightsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_insights(inputs)
});
export { nav_insights as "nav.insights" }